import React, { Component } from 'react';
import { Step } from 'semantic-ui-react';

class StepGroup extends Component {
  render() {
    let stepFlag;
    if (this.props.status === 'wait') {
      stepFlag = {
        wait: { active: true, disabled: false},
        scan: { active: false, disabled: true},
        paid: { active: false, disabled: true},
        verified: { active: false, disabled: true},
      }
    } else if (this.props.status === 'scan') {
      stepFlag = {
        wait: { active: false, disabled: false},
        scan: { active: true, disabled: false},
        paid: { active: false, disabled: true},
        verified: { active: false, disabled: true},
      }
    } else if (this.props.status === 'paid') {
      stepFlag = {
        wait: { active: false, disabled: false},
        scan: { active: false, disabled: false},
        paid: { active: true, disabled: false},
        verified: { active: false, disabled: true},
      }
    } else if (this.props.status === 'verified') {
      stepFlag = {
        wait: { active: false, disabled: false},
        scan: { active: false, disabled: false},
        paid: { active: false, disabled: false},
        verified: { active: true, disabled: false},
      }
    }
    return (
      <Step.Group widths={4} size='mini'>
        <Step active={stepFlag.wait.active} disabled={stepFlag.wait.disabled}>
          <Step.Content>
            <Step.Title>等待中</Step.Title>
          </Step.Content>
        </Step>
        <Step active={stepFlag.scan.active} disabled={stepFlag.scan.disabled}>
          <Step.Content>
            <Step.Title>付款中</Step.Title>
          </Step.Content>
        </Step>
        <Step active={stepFlag.paid.active} disabled={stepFlag.paid.disabled}>
          <Step.Content>
            <Step.Title>已付款</Step.Title>
          </Step.Content>
        </Step>
        <Step active={stepFlag.verified.active} disabled={stepFlag.verified.disabled}>
          <Step.Content>
            <Step.Title>已核實</Step.Title>
          </Step.Content>
        </Step>
      </Step.Group>
    )
  }
}

export default StepGroup;



// WEBPACK FOOTER //
// ./src/StepGroup.js